import React, { Component } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Close from '@mui/icons-material/Close'
import Search from '@mui/icons-material/Search'

import _ from 'lodash'
import { recuperarMenus } from '../../controllers/menusETCUUsuarioController'
import { removeAccents } from '../../util/stringUtil'
import { visualizarSistemaEGestao } from '../../controllers/itensController'

export class DialogMenusETCUUsuario extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menusUsuario: [],
      filtrarPor: ''
    }
  }

  handleDialogEnter() {
    recuperarMenus(this.carregarMenuUsuario.bind(this))
  }

  handleOperacoesProcessoMenuItemClick(codigoMenu) {
    visualizarSistemaEGestao(codigoMenu, (url) =>
      window.open(url, '_blank', 'toolbar=0,location=0,menubar=0')
    )
    this.handleClose()
  }

  handleFiltrarPorChange(event) {
    this.setState({ filtrarPor: event.target.value })
  }

  carregarMenuUsuario(menus) {
    this.setState({ menusUsuario: menus })
  }

  handleClose() {
    const { handleMenusUsuarioClose } = this.props
    this.setState({ menusUsuario: [] })
    handleMenusUsuarioClose()
  }

  renderGruposMenuUsuario() {
    const { menusUsuario, filtrarPor } = this.state
    if (!menusUsuario) return null
    const menus = menusUsuario
    const menuFiltered = _.filter(menus, (item) =>
      removeAccents(_.toUpper(item.titulo)).includes(removeAccents(_.toUpper(filtrarPor)))
    )
    return _.size(menus) ? _.map(menus, (menu) => this.renderSubMenus(menu, menuFiltered)) : null
  }

  renderSubMenus(menu, menusFiltered) {
    const { filtrarPor } = this.state
    const subMenusFiltered = _.filter(menu.subitens, (item) =>
      removeAccents(_.toUpper(item.titulo)).includes(removeAccents(_.toUpper(filtrarPor)))
    )
    return _.size(menu.subitens) && (_.find(menusFiltered, menu) || _.size(subMenusFiltered)) ? (
      <Grid container key={_.uniqueId('container-descricao-grupo-operacao-')}>
        <Grid
          container
          style={{ borderBottom: '1px solid #c8c8c8', padding: 13 }}
          key={_.uniqueId('descricao-grupo-operacao-')}>
          <Grid item xs={12}>
            <Typography variant='subtitle2' color='primary' style={{ fontSize: 18 }}>
              {menu.titulo}
            </Typography>
          </Grid>
          {this.renderItensMenu(_.find(menusFiltered, menu) ? menu.subitens : subMenusFiltered)}
        </Grid>
      </Grid>
    ) : null
  }

  renderItensMenu(subMenus) {
    if (!subMenus) return null
    return _.map(subMenus, (subMenu) => (
      <Grid item sm={4} key={_.uniqueId('operacao-processo-')}>
        <MenuItem
          sx={{ paddingLeft: 0, whiteSpace: 'normal' }}
          value={subMenu.codigo}
          onClick={() => this.handleOperacoesProcessoMenuItemClick(subMenu.codigo)}>
          {subMenu.titulo}
        </MenuItem>
      </Grid>
    ))
  }

  renderDialogContent() {
    const { filtrarPor, menusUsuario } = this.state
    return menusUsuario && _.size(menusUsuario) > 0 ? (
      <React.Fragment>
        <DialogTitle component='div' sx={{ margin: 0, padding: '0 16px' }}>
          <Grid container>
            <Grid item xs={8}>
              <Typography variant='h6' color='primary'>
                Menus
              </Typography>
              <Typography variant='subtitle1' color='textSecondary'>
                Selecione a opção desejada
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <TextField
                id='filtrarPorItems'
                type='search'
                variant='standard'
                style={{ width: 'calc(100% - 48px)' }}
                label={
                  <div style={{ alignItems: 'center', display: 'flex' }}>
                    <Search style={{ height: 18 }} />
                    Pesquisar
                  </div>
                }
                value={filtrarPor}
                onChange={(event) => this.handleFiltrarPorChange(event)}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <IconButton
          style={{ position: 'absolute', right: 8, top: 8 }}
          onClick={() => this.handleClose()}>
          <Close />
        </IconButton>
        <DialogContent sx={{ margin: 0, padding: '15px 5px 5px 5px' }}>
          {this.renderGruposMenuUsuario()}
        </DialogContent>
      </React.Fragment>
    ) : null
  }

  render() {
    const { open } = this.props

    return open ? (
      <Dialog
        open={open}
        fullScreen
        PaperProps={{ sx: { maxHeight: '90vh', maxWidth: '65vw' } }}
        TransitionProps={{ onEnter: this.handleDialogEnter.bind(this) }}>
        <Grid style={{ padding: '22px 26px' }}>{this.renderDialogContent()}</Grid>
      </Dialog>
    ) : null
  }
}

export default DialogMenusETCUUsuario
